import template from './messageEditTrigger.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onMessageEditTrigger((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                stage: params.stage,
                message: params.message
              },
              template,
              controllerAs: '$ctrl',
              controller(stage, message) {
                const ctr = this;
                ctr.stage = stage;
                ctr.message = message;
                ctr.options = { id: message.id, onEnter: true, onStale: false };
                if (stage && stage.opMessages) {
                  const op = _.find(stage.opMessages, (o) => o.id === message.id);
                  if (op && op.id) {
                    ctr.options = op;
                  }
                }

                ctr.toggleOption = (option) => {
                  for (const prop in ctr.options) {
                    if (ctr.options.hasOwnProperty(prop) && prop !== 'id' && prop !== option) {
                      ctr.options[prop] = false;
                    }
                  }
                };

                ctr.confirm = () => {
                  $mdDialog.hide(ctr.options);
                };

                ctr.cancel = () => {
                  $mdDialog.hide(ctr.options);
                };
              }
            })
            .then((options) => {
              if (ctrl.onFinished) {
                ctrl.onFinished({
                  stage: params.stage,
                  message: params.message,
                  options
                });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
